export const STRAIGHT_THRESHOLD_LOWER = 0.5;
export const STRAIGHT_THRESHOLD_UPPER = 2;
export const FACE_DETECT_TIMEOUT_MS = 15000;
